import {FC, ReactNode, useState} from 'react';
//mui
import {Box, IconButton, SxProps, Theme} from '@mui/material';
//images
import {ReactComponent as More} from '@icons/more-vertical.svg';
import {ReactComponent as Dots} from '@icons/dots-six-vertical-light.svg';

//components
import Dropdown from '@/shared/components/Dropdown';
//styles
import {actionsMenuStyle} from './ActionsMenu.styles';

interface ActionsMenuProps {
	content: ReactNode;
	sx?: SxProps<Theme>;
	parentClassName?: SxProps<Theme>;
	disableRipple?: boolean;
	isSixDots?: boolean;
}

const ActionsMenu: FC<ActionsMenuProps> = ({content, sx, parentClassName, disableRipple, isSixDots}) => {
	const [isOpened, setIsOpened] = useState(false);

	return (
		<Box sx={parentClassName}>
			<Dropdown
				sx={sx}
				toggleContent={
					<IconButton
						disableRipple={disableRipple}
						sx={{...(isOpened ? actionsMenuStyle.activeButton : actionsMenuStyle.button)}}
					>
						{isSixDots ? <Dots /> : <More />}
					</IconButton>
				}
				options={<Box sx={actionsMenuStyle.options}>{content}</Box>}
				open={isOpened}
				onOpen={() => setIsOpened(true)}
				onClose={() => setIsOpened(false)}
			/>
		</Box>
	);
};

export default ActionsMenu;
